import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Paper,
  Rating,
  Switch,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Constants from "../../../data/Constants";
import { getUserCart } from "services/cart.service";
import CourseCard from "components/CourseCard";
import CartItem from "components/CartItem";
import { TbShoppingCartDiscount } from "react-icons/tb";

function Cart(props) {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const { id } = useParams();
  if (!id) {
    navigate("/dashboard/mentees/");
  }
  const { setProgress, setToast } = useOutletContext();

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const res = await getUserCart(id);
        if (res) {
          setData(res);
          console.log(res);
          setProgress(false);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      } catch (error) {
        // error
        console.log(error);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
        setProgress(false);
      }
    }
    api();
  }, []);

  return (
    data && (
      <div>
        <h1 className="text-xl font-extrabold flex gap-2 items-center">
          {" "}
          <TbShoppingCartDiscount size={32} /> User Cart Items
        </h1>

        <div className="flex gap-4 py-4 flex-wrap">
          {data.courses.length + data.counselling.length == 0 && (
            <div className="py-5 text-gray-600"> User's Cart is Empty </div>
          )}

          {data.courses.map((courseObj) => {
            return <CartItem item={courseObj} />;
          })}

          {data.counselling.map((counsellingObj) => {
            return <CartItem item={counsellingObj} />;
          })}
        </div>

        <div className="flex gap-4 py-4"></div>
      </div>
    )
  );
}

export default Cart;
